import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteDocumentsListError, deleteDocumentsListSuccess,

    getDocumentsListError,
    getDocumentsListSuccess
} from './actions';
import {
    DOCUMENTS_DELETE_ITEMS, DOCUMENTS_GET_LIST, DOCUMENTS_GET_LIST_SEARCH,
    MY_POSTS_GET_LIST
} from './actions_def';


const apiUrl = servicePath;


function* getDocumentsList({ payload }) {
    //// // console.log(payload);;
    if (!payload) {
        yield put(getDocumentsListError({ error: 'prerequisites' }));
    }

    try {
        const response = yield call(getDocumentsListRequest, payload);
        yield put(getDocumentsListSuccess(response));
    } catch (error) {
        yield put(getDocumentsListError(error));
    }
}



function* getMyPostsList({ payload }) {
    //// // console.log(payload);;
    if (!payload) {
        yield put(getDocumentsListError({ error: 'prerequisites' }));
    }

    try {
        const response = yield call(getMyPostsRequest, payload);
        yield put(getDocumentsListSuccess(response));
    } catch (error) {
        yield put(getDocumentsListError(error));
    }
}



function* getDocumentsListSearch({ payload }) {
    // // console.log(payload);;
    if (!payload) {
        yield put(getDocumentsListError({ error: 'prerequisites' }));
    }

    try {
        const response = yield call(getDocumentsListSearchRequest, payload);
        yield put(getDocumentsListSuccess(response));
    } catch (error) {
        yield put(getDocumentsListError(error));
    }
}

const getDocumentsListRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        console.log(payload);;

        instance.get('/projects/' + payload.projectId + '/documents/')
            .then(response => success(response.data ?
                response.data.map(item => (item))
                :
                [])
            );
    })
        .then((response) => response)
        .catch((error) => error);
};


const getMyPostsRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.get('/posts/myposts/',
        )
            .then(response => success(response.data ?
                response.data.map(item => (item))
                :
                [])
            );
    })
        .then((response) => response)
        .catch((error) => error);
};
const getDocumentsListSearchRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // // console.log(payload);;

        instance.post('/projects/' + payload.projectId + '/documents/',
            {
                // crossdomain: true,
                projectId: payload.projectId,
                searchTerm: payload.searchTerm
            })
            .then(response => success(
                response.data ?
                    response.data.map(item => (item))
                    :
                    [])
            );
    })
        .then((response) => response)
        .catch((error) => error);
};
const deleteDocumentsListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (items.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        items.map(item => {
            console.log(item)
            instance.delete('/documents/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.status === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.status === "success" || response.data.status === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.status)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteDocumentsList({ payload }) {
    // // console.log(payload);;

    try {
        const response = yield call(deleteDocumentsListRequest, payload);
        yield put(deleteDocumentsListSuccess(response));
    } catch (error) {
        yield put(deleteDocumentsListError(error));
    }
}



export function* watchGetDocumentsList() {
    yield takeEvery(DOCUMENTS_GET_LIST, getDocumentsList);
}

export function* watchGetMyPostsList() {
    yield takeEvery(MY_POSTS_GET_LIST, getMyPostsList);
}

export function* watchGetSearchDocumentsList() {
    yield takeEvery(DOCUMENTS_GET_LIST_SEARCH, getDocumentsListSearch);
}

export function* watchDeleteDocuments() {
    yield takeEvery(DOCUMENTS_DELETE_ITEMS, deleteDocumentsList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetDocumentsList),
        fork(watchGetSearchDocumentsList),
        fork(watchDeleteDocuments),
    ]);
}
